var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicProfileImgBoneGd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88773_2142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5825 50.6603L80.9391 35.8506L104.542 59.4532C104.842 57.1783 105 54.8573 105 52.5C105 23.5037 81.493 0 52.5 0C23.507 0 0 23.5037 0 52.5C0 81.4963 23.5037 105 52.5 105C54.8573 105 57.1783 104.842 59.4532 104.542L17.111 62.1995L71.5792 50.6603H71.5825Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.542 59.4532L80.939 35.8506L71.5824 50.6603L17.1108 62.1995L59.4498 104.538C82.8842 101.439 101.439 82.8843 104.538 59.4499L104.542 59.4532Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.542 59.4532L80.939 35.8506L71.5824 50.6603L17.1108 62.1995L59.4498 104.538C82.8842 101.439 101.439 82.8843 104.538 59.4499L104.542 59.4532Z",
    fill: "url(#paint0_linear_88773_2142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5001 43.3774H38.3465C38.0234 43.3774 37.7102 43.2488 37.4827 43.0181L30.3152 35.8506C30.0844 35.6198 29.7745 35.4912 29.4514 35.4912H24.928C24.6049 35.4912 24.2917 35.6198 24.0643 35.8506L17.1177 42.7972C16.8869 43.0279 16.7583 43.3379 16.7583 43.661V48.2371C16.7583 48.5602 16.8869 48.8734 17.1177 49.1009L19.6497 51.6329C20.1277 52.1109 20.1277 52.8857 19.6497 53.3605L17.1177 55.8925C16.8869 56.1233 16.7583 56.4332 16.7583 56.7563V61.3324C16.7583 61.6555 16.8869 61.9687 17.1177 62.1962L24.0643 69.1428C24.295 69.3736 24.6049 69.5021 24.928 69.5021H29.4514C29.7745 69.5021 30.0877 69.3736 30.3152 69.1428L37.4827 61.9753C37.7135 61.7445 38.0234 61.6159 38.3465 61.6159H66.6537C66.9768 61.6159 67.29 61.7445 67.5175 61.9753L74.685 69.1428C74.9158 69.3736 75.2257 69.5021 75.5488 69.5021H80.0722C80.3953 69.5021 80.7085 69.3736 80.936 69.1428L87.8825 62.1962C88.1133 61.9654 88.2419 61.6555 88.2419 61.3324V56.7563C88.2419 56.4332 88.1133 56.12 87.8825 55.8925L85.3505 53.3605C84.8725 52.8824 84.8725 52.1076 85.3505 51.6329L87.8825 49.1009C88.1133 48.8701 88.2419 48.5602 88.2419 48.2371V43.661C88.2419 43.3379 88.1133 43.0246 87.8825 42.7972L80.936 35.8506C80.7052 35.6198 80.3953 35.4912 80.0722 35.4912H75.5488C75.2257 35.4912 74.9125 35.6198 74.685 35.8506L67.5175 43.0181C67.2867 43.2488 66.9768 43.3774 66.6537 43.3774H52.5001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7062 48.6129H42.6357V52.711H44.7062V48.6129Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2938 52.7077H62.3643V48.6096H60.2938V52.7077Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 59.0081L48.9888 55.5002L49.7471 54.7419L52.5 57.4981L55.2529 54.7419L56.0079 55.5002L52.5 59.0081Z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88773_2142",
    x1: 54.5242,
    y1: 53.1363,
    x2: 79.2444,
    y2: 83.2964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88773_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicProfileImgBoneGd);
export default __webpack_public_path__ + "static/media/basic-profile-img-bone-gd.c00f2fa53e0115855b385d2158d4e856.svg";
export { ForwardRef as ReactComponent };